<p>buyers-data-empty works!</p>
